const KEY = "mlobox_spin_session_v1";
const PENDING = "mlobox_pending_reward_v1";

export const loadSpinSession = () => {
  try { return JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
};
export const saveSpinSession = (s) => localStorage.setItem(KEY, JSON.stringify(s));
export const clearSpinSession = () => localStorage.removeItem(KEY);

export const setPendingReward = (code) => localStorage.setItem(PENDING, code);
export const getPendingReward = () => localStorage.getItem(PENDING) || "";
export const clearPendingReward = () => localStorage.removeItem(PENDING);

export const fmtExpiry = (iso) => new Date(iso).toLocaleString("en-KE", {
  weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", timeZone: "Africa/Nairobi",
});
